var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25C2.41421 1.25 2.75 1.58579 2.75 2V20C2.75 20.6904 3.30964 21.25 4 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V2C1.25 1.58579 1.58579 1.25 2 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1821 17.7673C11.2726 16.6767 11.2726 14.9085 10.1821 13.8179C9.09149 12.7274 7.32331 12.7274 6.23273 13.8179C5.48886 14.5618 5.14729 16.7408 5.0053 18.0511C4.94563 18.6017 5.3983 19.0544 5.94893 18.9947C7.25919 18.8527 9.43819 18.5111 10.1821 17.7673Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 2.89838C21.9729 4.98619 21.1176 6.99922 19.6222 8.49463L16.4127 11.7042L16.8873 13.1795C17.057 13.7071 16.9115 14.293 16.5115 14.693L15.3159 15.8886C15.17 16.0345 14.9366 16.0375 14.7945 15.8953L8.10466 9.20552C7.96253 9.06342 7.96554 8.82998 8.11138 8.68414L9.30699 7.48853C9.70701 7.08851 10.2929 6.94303 10.8205 7.11273L12.2958 7.58732L15.5054 4.37778C17.0008 2.88237 19.0138 2.02709 21.1016 2.00008C21.6042 1.99358 22.0064 2.39576 21.9999 2.89838Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessRocket);
export default __webpack_public_path__ + "static/media/business-rocket.8656229586a3a8b3bc54942db026c716.svg";
export { ForwardRef as ReactComponent };